export enum RoutesParams {
  exerciseId = ":exerciseId?",
}

export const ROUTES = {
  typingTutor: {
    index: "/typing-tutor/",
    selectCourse: "select-course/",
    selectExercise: "select-exercise/",
    settings: "settings/",
    store: "store/",
  },
  testStringResult: "/typing-tutor/test-string-results/",
  exerciseResults: "/typing-tutor/exercise-results/",
  challengeComplete: "/typing-tutor/challenge-complete/",
  lessonComplete: "/typing-tutor/lesson-complete/",
  courseComplete: "/typing-tutor/course-complete/",
};

export const EXTERNAL_ROUTES = {
  signup: "/signup/",
  removeAds: "/ratatype-plus/",
};
